export const PrinterIcon = ({ ...rest }) => {
  return (
    <svg
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect
        x="1.36"
        y="1.36"
        width="65.28"
        height="65.28"
        rx="32.64"
        fill="white"
      />
      <rect
        x="1.36"
        y="1.36"
        width="65.28"
        height="65.28"
        rx="32.64"
        stroke="#696677"
        strokeWidth="1.28"
      />
      <path
        d="M38.9999 37.6667H43.2499C44.0323 37.6667 44.6666 37.0324 44.6666 36.25V27.75C44.6666 26.9676 44.0323 26.3333 43.2499 26.3333H17.7499C16.9675 26.3333 16.3333 26.9676 16.3333 27.75V36.25C16.3333 37.0324 16.9675 37.6667 17.7499 37.6667H21.9999"
        stroke="#696677"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 32H39V43.3333C39 44.1158 38.3658 44.75 37.5833 44.75H23.4167C22.6343 44.75 22 44.1158 22 43.3333V32Z"
        stroke="#696677"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 20.6667C22 19.8843 22.6343 19.25 23.4167 19.25H37.5833C38.3658 19.25 39 19.8843 39 20.6667V26.3333H22V20.6667Z"
        stroke="#696677"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.8997 45.7636C34.2958 45.7087 33.8335 45.2024 33.8335 44.5961L33.8335 43.4039C33.8335 42.7976 34.2958 42.2913 34.8997 42.2364C35.3954 42.1913 35.8001 41.8345 35.9748 41.3684C36.0197 41.2486 36.0676 41.1302 36.1184 41.0133C36.3188 40.5521 36.2804 40.0096 35.9585 39.6234C35.5607 39.146 35.5925 38.444 36.0319 38.0046L36.8734 37.1631C37.2923 36.7442 37.9616 36.7139 38.4168 37.0932C38.7959 37.4091 39.3312 37.4385 39.7766 37.2261C39.9695 37.1342 40.167 37.0502 40.3686 36.9747C40.8347 36.7999 41.1915 36.3952 41.2366 35.8995C41.2915 35.2957 41.7978 34.8333 42.4041 34.8333L43.5963 34.8333C44.2026 34.8333 44.7088 35.2957 44.7637 35.8995C44.8088 36.3952 45.1656 36.7999 45.6317 36.9747C45.8127 37.0425 45.9903 37.1171 46.1643 37.1981C46.5871 37.3951 47.0919 37.3632 47.4502 37.0647C47.886 36.7015 48.5268 36.7305 48.928 37.1317L49.8685 38.0722C50.2696 38.4733 50.2987 39.1142 49.9355 39.5499C49.6369 39.9083 49.605 40.4131 49.802 40.8358C49.883 41.0098 49.9577 41.1875 50.0255 41.3684C50.2002 41.8345 50.6049 42.1913 51.1007 42.2364C51.7045 42.2913 52.1668 42.7976 52.1668 43.4039L52.1668 44.5961C52.1668 45.2024 51.7045 45.7087 51.1007 45.7636C50.6049 45.8087 50.2002 46.1655 50.0255 46.6316C49.95 46.8332 49.866 47.0306 49.7741 47.2235C49.5617 47.669 49.5911 48.2043 49.907 48.5834C50.2863 49.0386 50.256 49.7078 49.837 50.1268L48.9955 50.9682C48.5562 51.4076 47.8542 51.4395 47.3768 51.0417C46.9905 50.7197 46.448 50.6813 45.9868 50.8817C45.87 50.9325 45.7516 50.9804 45.6317 51.0253C45.1656 51.2 44.8088 51.6047 44.7637 52.1005C44.7088 52.7043 44.2026 53.1667 43.5963 53.1667L42.4041 53.1667C41.7978 53.1667 41.2915 52.7043 41.2366 52.1005C41.1915 51.6047 40.8347 51.2 40.3686 51.0253C40.2277 50.9725 40.0888 50.9156 39.9521 50.8547C39.4684 50.6393 38.8959 50.6751 38.489 51.0141C37.9929 51.4275 37.2635 51.3944 36.8068 50.9378L36.0623 50.1933C35.6057 49.7367 35.5726 49.0072 35.986 48.5111C36.325 48.1043 36.3608 47.5318 36.1454 47.048C36.0845 46.9113 36.0276 46.7725 35.9748 46.6316C35.8001 46.1655 35.3954 45.8087 34.8997 45.7636Z"
        fill="white"
        stroke="#15112D"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43 41.25C44.5188 41.25 45.75 42.4812 45.75 44C45.75 45.5188 44.5188 46.75 43 46.75C41.4812 46.75 40.25 45.5188 40.25 44C40.25 42.4812 41.4812 41.25 43 41.25Z"
        stroke="#15112D"
        strokeWidth="1.375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
